
export default {
  props: {
    error: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    title () {
      const titles = {
        403: 'ممنوع الوصول',
        404: 'الصفحة غير موجودة',
        500: 'خطأ في الخادم'
      }
      return titles[this.error.statusCode] || 'حدث خطأ'
    },
    message () {
      if (this.error.message) { return this.error.message }
      const messages = {
        403: 'ليس لديك صلاحية للوصول إلى هذا القسم',
        404: 'الصفحة التي تبحث عنها غير موجودة',
        500: 'حدث خطأ غير متوقع، يرجى المحاولة لاحقاً'
      }
      return messages[this.error.statusCode] || 'حدث خطأ غير متوقع'
    }
  }
}
